

import Vue from "vue";

import { storeInstance, routerInstance, vueI18nInstance } from '@mods/index.js'
import routes from "./router/index";
import store from "./store/index";
import mixins from "./mixins";

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV != 'production';

Vue.mixin(mixins);
new Vue({
    el: "#app",
    i18n: vueI18nInstance(),
    router: routerInstance(routes, [{ path: "/", redirect: { name: "homePanel" } }]),
    store: storeInstance(store, ['boss/actionInit', 'diction/actionInit']),
});



